import { MdEdit } from 'react-icons/md'

export const team_columns = [
  {
    id: 'name',
    label: 'Name',
    minWidth: 100,
    hide: []
  },
  {
    id: 'organisation',
    label: 'Organisation',
    minWidth: 100,
    hide: []
  },
]

const roleLabels = {
  admin: 'Admin',
  'fleet manager': 'Manager',
  standard: 'User'
}

export const userTeam_columns = [
  {
    id: 'name',
    label: 'Name',
    minWidth: 100,
    hide: []
  },
  {
    id: 'privilege',
    label: 'Role',
    minWidth: 100,
    hide: [],
    render: (value) => (
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <span>{roleLabels[value]}</span>
        <MdEdit style={{ color: '#666' }} />
      </div>
    )
  },
  {
    id: 'email',
    label: 'Email',
    minWidth: 100,
    hide: []
  },
]

export const addVehicleTeam_columns = [

  {
    id: 'vehicleName',
    label: 'Vehicle name',
    minWidth: 100,
    hide: []
  },
  {
    id: 'model',
    label: 'Model',
    minWidth: 100,
    hide: []
  },
  {
    id: 'year',
    label: 'Year',
    minWidth: 100,
    hide: []
  },
  {
    id: 'licenseNumber',
    label: 'Lic number',
    minWidth: 100,
    hide: []
  },

]

export const vehicleTeam_columns = [

  {
    id: 'vehicleName',
    label: 'Vehicle name',
    minWidth: 100,
    hide: []
  },
  {
    id: 'model',
    label: 'Model',
    minWidth: 100,
    hide: []
  },
  {
    id: 'year',
    label: 'Year',
    minWidth: 100,
    hide: []
  },
  {
    id: 'licenseNumber',
    label: 'Lic number',
    minWidth: 100,
    hide: []
  },

]

export const userModal_columns = [
  {
    id: 'name',
    label: 'Name',
    minWidth: 100,
    hide: []
  },
  {
    id: 'email',
    label: 'Email',
    minWidth: 100,
    hide: []
  },
]

export const allTeams_columns = [
  {
    id: 'name',
    label: 'Name',
    minWidth: 100,
    hide: []
  },
  {
    id: 'privilege',
    label: 'Role',
    minWidth: 100,
    hide: [],
    render: (value) => (
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <span>{roleLabels[value]}</span>
      </div>
    )
  },
  {
    id: 'email',
    label: 'Email',
    minWidth: 100,
    hide: []
  },
  {
    id: 'date',
    label: 'Date',
    minWidth: 100,
    hide: []
  },
  {
    id: 'team',
    label: 'Team',
    minWidth: 100,
    hide: []
  },
]

export const allVehicles_columns = [

  {
    id: 'vehicleName',
    label: 'Vehicle name',
    minWidth: 100,
    hide: []
  },
  {
    id: 'model',
    label: 'Model',
    minWidth: 100,
    hide: []
  },
  {
    id: 'year',
    label: 'Year',
    minWidth: 100,
    hide: []
  },
  {
    id: 'licenseNumber',
    label: 'Lic number',
    minWidth: 100,
    hide: []
  },
  {
    id: 'date',
    label: 'Date',
    minWidth: 100,
    hide: []
  },
  {
    id: 'team',
    label: 'Team',
    minWidth: 100,
    hide: []
  },
]
